import { apiClient } from "@/lib/apiClient";

export interface OutboundCallResponse {
  callSid: string;
  sessionId: string;
  status: string;
}

export interface CallStatusResponse {
  callSid: string;
  status: string;
  duration: string | null;
  sessionId: string | null;
}

export interface InitiateCallParams {
  toNumber: string;
  companyId: string;
  userId: string;
  customPrompt?: string;
}

export async function initiateCall(
  params: InitiateCallParams
): Promise<OutboundCallResponse> {
  return apiClient.post<OutboundCallResponse>("/v1/calls/outbound", {
    data: params,
  });
}

export async function getCallStatus(
  callSid: string
): Promise<CallStatusResponse> {
  return apiClient.get<CallStatusResponse>(`/v1/calls/${callSid}/status`);
}

export async function endCall(callSid: string): Promise<{ success: boolean; message: string }> {
  return apiClient.post<{ success: boolean; message: string }>(
    `/v1/calls/${callSid}/end`
  );
}
